import PropTypes from 'prop-types';
import s from './MaterialIcon.module.scss';
import classNames from 'classnames';

const MaterialIcon = ({ name, isBlack }) => {
    const classes = classNames(s.Icon, {
        [s.Black]: isBlack,
    });
    if (!name) {
        return null;
    }

    return <span className={classes}>{name}</span>;
};

MaterialIcon.propTypes = {
    name: PropTypes.string.isRequired,
};

export default MaterialIcon;
